import { Exception } from 'src/app/core/logic/exception';

export class TemplateNotFoundException extends Exception<never> {
  constructor() {
    super('Template non trouvé');
  }
}

export class TemplateExistingNameException extends Exception<string> {
  constructor(name: string) {
    super(`Un template avec le nom "${name}" existe déjà`, name);
  }
}
